import React from 'react';
import style from './mobilebutton.less';
import Button from 'components/UI/Form/Button';

const MobileButton = ({ open, className, onClick }) => (
	<Button onClick={onClick} clearStyle className={`${style.menu} ${open && style.open} ${className}`}><span /></Button>
);


export default MobileButton;